import { createSelector } from 'reselect'
import { RootState } from '../store'

const getStates = (state: RootState) => state.americanStates.data.states
const getSelectedState = (state: RootState) => state.americanStates.data.selectedState
const fetchingStates = (state: RootState) => state.americanStates.loading

const makeSortedStates = createSelector(
  [getStates],
  (states) => {
      if (!Array.isArray(states)) {
          return [];
      }
      return states
          .filter((state) => typeof state.state === 'string')
          .sort((a, b) => a.state.localeCompare(b.state));
  }
)


const makeSelectedStateCoordinates = createSelector([getSelectedState],(selectedState)=>{
  if(selectedState && selectedState.location){
    return  {
        lat: selectedState.location[0],
        lng: selectedState.location[1]
      }

  }else{
    return { lat: 39.8283, lng: -98.5795 }
  }
})

const makeSelectedStateDefaultZoom = createSelector([getSelectedState],(selectedState)=>{
  return (selectedState && selectedState.default_zoom) || 4
})

export const AmericanStatesSelector = {
  getStates,
  getSelectedState,
  fetchingStates,
  makeSortedStates,
  makeSelectedStateCoordinates,
  makeSelectedStateDefaultZoom
}
